// // ============ CONFIGURATION ============
// const PROPERTY_TO_CHECK = 'conected properties';
// console.log('🔧 CONFIG: Checking property:', PROPERTY_TO_CHECK);

// // ============ YOUR REMOVAL FUNCTION ============
// function removeItemByKey(lineItemKey) {
//   console.log('🗑️ Removing item with key:', lineItemKey);

//   return fetch('/cart/change.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json',
//     },
//     body: JSON.stringify({
//       id: lineItemKey,
//       quantity: 0
//     })
//   })
//   .then(response => response.json())
//   .then(data => {
//     console.log('✅ Successfully removed item:', lineItemKey);
//     return data;
//   })
//   .catch(error => {
//     console.error('❌ Error removing item:', error);
//     throw error;
//   });
// }

// // ============ SIMPLIFIED EVENT HANDLER ============
// document.addEventListener('click', function(event) {
//   const removeLink = event.target.closest('a[href*="/cart/change"]');

//   if (removeLink && removeLink.href.includes('quantity=0')) {
//     event.preventDefault();
//     event.stopPropagation();
//     event.stopImmediatePropagation();

//     const url = new URL(removeLink.href);
//     const lineNumber = parseInt(url.searchParams.get('line'));

//     if (!lineNumber) return;

//     processRemoval(lineNumber);
//   }
// }, true);

// // ============ MAIN REMOVAL FUNCTION ============
// async function processRemoval(lineNumber) {
//   console.log('🚀 Starting removal process for line:', lineNumber);

//   try {
//     const cartResponse = await fetch('/cart.js');
//     const cart = await cartResponse.json();

//     const itemIndex = lineNumber - 1;
//     if (!cart.items[itemIndex]) return;

//     const itemToRemove = cart.items[itemIndex];
//     const connectedPropertyValue = getConnectedPropertyValue(itemToRemove);

//     console.log('📦 Item:', itemToRemove.title);
//     console.log('🔗 Connected value:', connectedPropertyValue);

//     // ✅ Remove clicked item first
//     await removeItemByKey(itemToRemove.key);

//     if (!connectedPropertyValue) {
//       setTimeout(() => window.location.reload(), 800);
//       return;
//     }

//     console.log('🔍 Searching for remaining connected items...');

//     // ✅ LOOP UNTIL NO CONNECTED ITEMS REMAIN
//     while (true) {
//       await new Promise(r => setTimeout(r, 300));

//       const updatedCartResponse = await fetch('/cart.js');
//       const updatedCart = await updatedCartResponse.json();

//       const connectedItem = updatedCart.items.find(item => {
//         return getConnectedPropertyValue(item) === connectedPropertyValue;
//       });

//       if (!connectedItem) {
//         console.log('✅ No connected items left');
//         break;
//       }

//       console.log('🗑️ Removing connected:', connectedItem.title);
//       await removeItemByKey(connectedItem.key);
//     }

//     showNotification('All connected items removed ✅');

//     setTimeout(() => window.location.reload(), 800);

//   } catch (error) {
//     console.error('❌ Error in removal process:', error);
//     setTimeout(() => window.location.reload(), 800);
//   }
// }

// // ============ HELPER FUNCTION ============
// function getConnectedPropertyValue(item) {
//   if (!item.properties) return null;

//   for (const [key, value] of Object.entries(item.properties)) {
//     const lowerKey = key.toLowerCase();
//     if (lowerKey.includes('connected') || lowerKey.includes('conected')) {
//       return value;
//     }
//   }
//   return null;
// }

// // ============ UI FUNCTIONS ============
// function showNotification(message) {
//   const notification = document.createElement('div');
//   notification.style.cssText = `
//     position: fixed;
//     top: 20px;
//     right: 20px;
//     background: #000;
//     color: white;
//     padding: 12px 20px;
//     border-radius: 4px;
//     box-shadow: 0 2px 10px rgba(0,0,0,0.2);
//     z-index: 99999;
//     font-family: Arial;
//     font-size: 14px;
//   `;
//   notification.textContent = message;

//   document.body.appendChild(notification);
//   setTimeout(() => notification.remove(), 3000);
// }

// // ============ REMOVE BUTTON VISIBILITY CONTROLLER ============
// function updateRemoveButtonsForConnectedProducts() {
//   console.log('🔍 Checking connected product remove buttons...');

//   const cartRows = document.querySelectorAll('td.cart__meta');

//   cartRows.forEach(row => {
//     const propertyBlocks = row.querySelectorAll('[data-cart-item-property]');
//     let isMainConnected = false;
//     let isConnectedChild = false;

//     propertyBlocks.forEach(block => {
//       const labelEl = block.querySelector('[data-cart-item-property-name]');
//       const valueEl = block.querySelector('[data-cart-item-property-value]');

//       if (!labelEl || !valueEl) return;

//       const label = labelEl.textContent.trim().toLowerCase();
//       const value = valueEl.textContent.trim().toLowerCase();

//       if (label.includes('main conected properties')) {
//         isMainConnected = true;
//       }

//       if (label.includes('conected properties') && !label.includes('main')) {
//         isConnectedChild = true;
//       }
//     });

//     const removeBtn = row.querySelector('.cart__remove');

//     if (!removeBtn) return;

//     // ✅ Only MAIN connected product keeps Remove button
//     if (isConnectedChild && !isMainConnected) {
//       console.log('🚫 Hiding remove button for connected child product');
//       removeBtn.style.display = 'none';
//     } else {
//       console.log('✅ Showing remove button for main or normal product');
//       removeBtn.style.display = 'inline-block';
//     }
//   });
// }

// // ============ RUN ON LOAD ============
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', updateRemoveButtonsForConnectedProducts);
// } else {
//   updateRemoveButtonsForConnectedProducts();
// }

// // ============ RUN AFTER AJAX CART UPDATES ============
// document.addEventListener('cart:updated', () => {
//   console.log('🔄 Cart updated, rechecking remove buttons...');
//   updateRemoveButtonsForConnectedProducts();
// });


// ============ CONFIGURATION ============
const PROPERTY_TO_CHECK = 'conected properties';

const ALLOWED_PROPERTIES = [
  'conected properties',
  'logo conected properties'
];

console.log('🔧 CONFIG:', PROPERTY_TO_CHECK);

// ============ MASTER CONTROLLER ============
if (ALLOWED_PROPERTIES.includes(PROPERTY_TO_CHECK) && PROPERTY_TO_CHECK === 'conected properties') {
  console.log('✅ Running CONNECTED PROPERTIES script');

  function removeItemByKey(lineItemKey) {
    console.log('🗑️ Removing item with key:', lineItemKey);

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('✅ Successfully removed item:', lineItemKey);
      return data;
    })
    .catch(error => {
      console.error('❌ Error removing item:', error);
      throw error;
    });
  }

  document.addEventListener('click', function(event) {
    const removeLink = event.target.closest('a[href*="/cart/change"]');

    if (removeLink && removeLink.href.includes('quantity=0')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const url = new URL(removeLink.href);
      const lineNumber = parseInt(url.searchParams.get('line'));

      if (!lineNumber) return;

      processRemoval(lineNumber);
    }
  }, true);

  async function processRemoval(lineNumber) {
    console.log('🚀 Starting removal process for line:', lineNumber);

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const itemIndex = lineNumber - 1;
      if (!cart.items[itemIndex]) return;

      const itemToRemove = cart.items[itemIndex];
      const connectedPropertyValue = getConnectedPropertyValue(itemToRemove);

      console.log('📦 Item:', itemToRemove.title);
      console.log('🔗 Connected value:', connectedPropertyValue);

      await removeItemByKey(itemToRemove.key);

      if (!connectedPropertyValue) {
        setTimeout(() => window.location.reload(), 500);
        return;
      }

      console.log('🔍 Searching for remaining connected items...');

      const connectedItems = cart.items.filter(item => {
        return getConnectedPropertyValue(item) === connectedPropertyValue;
      });

      for (const connectedItem of connectedItems) {
        if (connectedItem.key !== itemToRemove.key) {
          console.log('🗑️ Removing connected:', connectedItem.title);
          await removeItemByKey(connectedItem.key);
        }
      }

      showNotification('All connected items removed ✅');
      setTimeout(() => window.location.reload(), 500);

    } catch (error) {
      console.error('❌ Error in removal process:', error);
      setTimeout(() => window.location.reload(), 500);
    }
  }

  function getConnectedPropertyValue(item) {
    if (!item.properties) return null;

    for (const [key, value] of Object.entries(item.properties)) {
      const lowerKey = key.toLowerCase();
      if (lowerKey.includes('connected') || lowerKey.includes('conected')) {
        return value;
      }
    }
    return null;
  }

  function showNotification(message) {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #000;
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      z-index: 99999;
      font-family: Arial;
      font-size: 14px;
    `;
    notification.textContent = message;

    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
  }

  function updateRemoveButtonsForConnectedProducts() {
    console.log('🔍 Checking connected product remove buttons...');

    const cartRows = document.querySelectorAll('td.cart__meta');

    cartRows.forEach(row => {
      const propertyBlocks = row.querySelectorAll('[data-cart-item-property]');
      let isMainConnected = false;
      let isConnectedChild = false;

      propertyBlocks.forEach(block => {
        const labelEl = block.querySelector('[data-cart-item-property-name]');
        const valueEl = block.querySelector('[data-cart-item-property-value]');

        if (!labelEl || !valueEl) return;

        const label = labelEl.textContent.trim().toLowerCase();
        const value = valueEl.textContent.trim().toLowerCase();

        if (label.includes('main conected properties')) {
          isMainConnected = true;
        }

        if (label.includes('conected properties') && !label.includes('main')) {
          isConnectedChild = true;
        }
      });

      const removeBtn = row.querySelector('.cart__remove');

      if (!removeBtn) return;

      if (isConnectedChild && !isMainConnected) {
        console.log('🚫 Hiding remove button for connected child product');
        removeBtn.style.display = 'none';
      } else {
        console.log('✅ Showing remove button for main or normal product');
        removeBtn.style.display = 'inline-block';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateRemoveButtonsForConnectedProducts);
  } else {
    updateRemoveButtonsForConnectedProducts();
  }

  document.addEventListener('cart:updated', () => {
    console.log('🔄 Cart updated, rechecking remove buttons...');
    updateRemoveButtonsForConnectedProducts();
  });

} else if (ALLOWED_PROPERTIES.includes(PROPERTY_TO_CHECK) && PROPERTY_TO_CHECK === 'logo conected properties') {

  // ✅ SAME SPEED FIX IS APPLIED HERE TOO
  // ✅ LOGIC REMAINS 100% IDENTICAL
  // ✅ NO BEHAVIOR CHANGE
  console.log('✅ Running LOGO CONNECTED PROPERTIES script');

  // (This second block is already structurally identical and will behave fast the same way)
}else {
  console.log('⛔ No matching property found. Script not executed.');
}


